import React, { useState } from 'react';

const FAQSection = () => {
  // To make all items closed by default, set initial activeIndex to -1
  const [activeIndex, setActiveIndex] = useState(-1); 

  const faqs = [
    {
      question: 'Where is The Porch located?',
      answer:
        'We are located in Kota city, offering a cozy rooftop ambiance perfect for casual outings, celebrations, and relaxing meals. Find us easily on Google Maps here.',
    },
    {
      question: 'Do you serve Jain food?',
      answer:
        'Yes, we offer Jain-friendly food options. Our chefs are happy to prepare dishes without onion, garlic, or root vegetables as per your request.',
    },
    {
      question: 'Do you provide home delivery or takeaway?',
      answer:
        'Yes, we deliver through Swiggy and Zomato, and takeaway is also available. Order directly from your favorite app or give us a call.',
    },
    {
      question: ' Do you host private parties or events?',
      answer:
        'Yes, we host birthday celebrations, kitty parties, and private gatherings. Contact us to discuss your event and arrangements.',
    },
    {
      question: ' Is prior reservation required?',
      answer:
        'Walk-ins are always welcome, but we recommend making a reservation during weekends or festive days to avoid waiting.',
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          /* Font imports within the style block for self-contained component */
          @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&family=Playfair+Display:wght@400;500;600;700&display=swap');

          /* Basic responsive adjustments for font sizes */
          @media (max-width: 767px) {
            .faq-heading-text { /* Class for the heading text */
              font-size: 2rem !important; /* Adjust heading size on smaller screens */
            }
            .faq-question-text-mobile { /* Class for question text on smaller screens */
              font-size: 1rem !important;
            }
            .faq-answer-text-mobile { /* Class for answer text on smaller screens */
              font-size: 0.875rem !important;
            }
          }
        `}
      </style>
      <h2 style={styles.heading} className="faq-heading-text">
        Frequently Asked <span style={styles.highlight}>Questions</span>
      </h2>

      <div style={styles.list}>
        {faqs.map((faq, idx) => (
          <div
            key={idx}
            onClick={() => toggleFAQ(idx)}
            style={{
              ...styles.item,
              ...(activeIndex === idx ? styles.itemActive : {}),
            }}
          >
            <div style={styles.questionRow}>
              <span style={styles.questionText} className="faq-question-text-mobile">
                {idx + 1}. {faq.question}
              </span>
              <span style={{...styles.plusIcon, ...(activeIndex === idx ? styles.activeIcon : {})}}>{activeIndex === idx ? '×' : '+'}</span>
            </div>
            {activeIndex === idx && (
              <div style={styles.answer} className="faq-answer-text-mobile">
                {faq.answer.split('here').map((part, i, arr) =>
                  i < arr.length - 1 ? (
                    <span key={i}>
                      {part}
                      {/* Updated link href and style to match parent text color and remove underline */}
                      <a 
                        href="https://www.google.com/maps/dir//The+Porch+Cafe+%26+Restaurant+Rooftop+Area,+Hotel+The+Pride+267,+Rajeev Gandhi Nagar,+Instrumentation+Limited+Colony+Kota,+Rajasthan+324005/@25.1375351,75.8483644,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x396f85c82fa55981:0xe56d0b917178f5a4" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={styles.link}
                      >
                        here
                      </a>
                    </span>
                  ) : (
                    part
                  )
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Open Sans', sans-serif",
    padding: '3rem 1rem',       // py-12 px-4
    maxWidth: '48rem',          // max-w-3xl
    width: '100%',
    margin: '0 auto',
    height: 'auto',             // ✅ Fit content height
    minHeight: 'auto',          // ✅ Override any full-height styles
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',   // Keep vertical centering if space allows
    alignItems: 'center',       // Horizontal centering
  },
  
  heading: {
    textAlign: 'center',
    fontSize: '2.5rem', // Adjusted to match image's larger title
    fontWeight: '600', // font-semibold for the whole heading
    marginBottom: '2.5rem', // mb-10
    color: '#121212', // Dark text color for the heading
    fontFamily: "'Playfair Display', serif", // Apply Playfair Display to title as seen in image
  },
  highlight: {
    color: '#d6a54f', // Matches the golden highlight in the image
    fontFamily: "'Playfair Display', serif", // Applied Playfair Display here for "Questions"
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem', // space-y-4 for gap between FAQ items
    width: '100%', // Ensure list takes full width of max-width container
  },
  item: {
    backgroundImage: 'linear-gradient(to right, #f4e8d9, #fdf7ee)', // Lighter gradient background for inactive
    backgroundColor: 'transparent', // Ensure transparent to let gradient show
    borderRadius: '0.375rem', // rounded-md
    paddingTop: '1rem',
    paddingRight: '1.5rem',
    paddingBottom: '1rem', // Base padding for inactive state, as seen in image
    paddingLeft: '1.5rem',
    cursor: 'pointer',
    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)', // Smooth transition for active/inactive
    display: 'flex',
    flexDirection: 'column', // Stack question and answer
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', // Subtle shadow for inactive state
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'transparent', // Default transparent border for inactive
    color: '#121212', // Dark text color for question in inactive state
  },
  itemActive: {
    backgroundImage: 'none', // Remove gradient for active state
    backgroundColor: '#1a1a1a', // Solid black background for active item
    color: '#ffffff', // White text for active question
    borderColor: '#1a1a1a', // Dark border for the active box
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.15)', // More prominent shadow for active item
    paddingBottom: '0.75rem', // Adjusted padding for spacing before answer in active state
  },
  activeIcon: {
    color: '#ffffff', // White color for the 'x' icon in the active state
    backgroundColor: '#1a1a1a', // Dark background for the 'x' icon
    borderRadius: '50%', // Make it circular
    width: '24px', // Adjust size for better visual
    height: '24px', // Adjust size
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.2rem', // Center the 'x'
  },
  questionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', // Align icon and text vertically
    fontSize: '1.125rem', // text-lg
    fontWeight: 'normal', // Question text looks normal/medium weight in image
  },
  questionText: {
    flex: 1,
    marginRight: '10px', // Space between text and icon
    fontFamily: "'Open Sans', sans-serif", // Changed to Open Sans for individual questions
  },
  plusIcon: {
    fontSize: '1.25rem', // text-xl, adjusted for better visual match for the icon size
    fontWeight: 'bold', // Plus/cross icon looks bold
    // No specific color here; it will inherit from item or itemActive,
    // or be overridden by activeIcon if applicable.
  },
  answer: {
    fontSize: '0.875rem', // text-sm
    marginTop: '0.5rem', // mt-2
    color: '#a1a1a1', // Light grey text for answer in active state
    lineHeight: '1.625', // leading-relaxed
    paddingTop: '0.5rem', // Add padding to separate answer from question
  },
  link: {
    color: 'inherit', // Inherit color from parent text (will be black or white)
    textDecoration: 'none', // Remove underline
    fontWeight: 'bold', // Make it bold to stand out slightly without underline
  },
};

export default FAQSection;
